// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/ui-kit-sb3/ui-kit-sb3.component.scss
// module id = 730
// module chunks = 0